// AccionesCell.jsx
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'context/AuthContext';

function AccionesCell({ document, onEdit, onDelete }) {
  const navigate = useNavigate();
  const { hasRole } = useContext(AuthContext);
  const canManage = hasRole('admin', 'user'); // solo admin/user pueden editar/eliminar

  const handleViewDocument = () => {
    if (!document || !document.dir) {
      console.error("No se encontró la propiedad 'dir' en el documento.");
      return;
    }
    const fileUrl = `${process.env.REACT_APP_SERVER_URL}/documentos/${document.dir}`;
    const ext = document.dir.split('.').pop().toLowerCase();
    if (['pdf', 'png', 'jpg', 'jpeg'].includes(ext)) {
      window.open(fileUrl, '_blank');
    } else if (['xls', 'xlsx', 'csv'].includes(ext)) {
      window.location.href = fileUrl;
    } else {
      window.open(fileUrl, '_blank');
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
      {/* Ver (siempre visible) */}
      <IconButton aria-label="ver" color="info" onClick={handleViewDocument}>
        <InsertDriveFileOutlinedIcon />
      </IconButton>

      {/* Editar y Eliminar solo para admin/user */}
      {canManage && (
        <>
          <IconButton aria-label="Editar" color="warning" onClick={onEdit}>
            <EditIcon />
          </IconButton>
          <IconButton aria-label="Eliminar" color="error" onClick={onDelete}>
            <DeleteIcon />
          </IconButton>
        </>
      )}
    </div>
  );
}

AccionesCell.propTypes = {
  document: PropTypes.shape({
    dir: PropTypes.string.isRequired,
  }).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default AccionesCell;
